import type { ApiRoute, NoPathParams, NoResponse } from "../../api"

export interface SetManualRoofColorQueryParams {
	"inventory-id": string
}

export interface SetManualRoofColorBody {
	hexCode: string
	name: Record<string, string>
	tagKey: string
}

export const setManualRoofColorRoute: ApiRoute<
	NoPathParams,
	SetManualRoofColorQueryParams,
	SetManualRoofColorBody,
	NoResponse
> = {
	buildUrl: () => "/colors/roof-color/manual",
	method: "post",
	path: "/colors/roof-color/manual",
}
